export default "__VITE_ASSET__DauIJP70__"